import { ProductCombinationInterface } from '@qlevr/shared/interfaces';
import isEmpty from 'lodash.isempty';

export function getCombinationByOptions(
  combinations: ProductCombinationInterface[] | null,
  activeOptions: Record<string, string | null>,
  defaultFallback?: ProductCombinationInterface,
): ProductCombinationInterface | null {
  try {
    if (!combinations || isEmpty(combinations)) {
      console.warn('No combinations provided.');
      return defaultFallback || null;
    }

    // If no active option is set, return a fallback (either provided or first combination)
    if (!Object.values(activeOptions).some((value) => !!value)) {
      console.warn('No active options set; returning fallback combination.');
      return defaultFallback || combinations[0] || null;
    }

    const matchedCombination = combinations.find((combination) =>
      Object.entries(activeOptions).every(([key, value]) => {
        if (!value) {
          // If a particular option is not set, ignore it
          return true;
        }
        if (!(key in combination)) {
          console.warn(`Combination missing property for key: ${key}`);
          return false;
        }
        return combination[key] === value;
      }),
    );

    if (!matchedCombination) {
      console.warn('No matching combination found; using fallback.');
      return defaultFallback || combinations[0] || null;
    }

    return matchedCombination;
  } catch (error) {
    console.error('Error in getCombinationByOptions:', error);
    return defaultFallback || (combinations && combinations.length > 0 ? combinations[0] : null);
  }
}
